// extracted by css-extract-rspack-plugin
export default {"container":"_c0a40e7d","checkbox":"_11d2b809","label":"_2558cf3c","stoneCutContainer":"_f08e297c","count":"_d60a7eb9","input":"_d852e88c","checked":"_ad36cedd"};